export const createApiTag = (type: string, id: string | number): any => ({ type, id })

export const provideListTags =
  (tag: string, tagId: string) =>
  <T extends { id: number }>(data: T[] | undefined): any =>
    data ? [...data.map(({ id }) => createApiTag(tag, id)), createApiTag(tag, tagId)] : [createApiTag(tag, tagId)]
